var $, createTypeaheadDataset, values,
  hasProp = {}.hasOwnProperty;

$ = window.jQuery;

values = function(object) {
  var key, results, value;
  results = [];
  for (key in object) {
    if (!hasProp.call(object, key)) continue;
    value = object[key];
    results.push(value);
  }
  return results;
};

createTypeaheadDataset = function(dataset) {
  var empty, typeaheadView;
  empty = $('<div>');
  typeaheadView = empty.typeahead(dataset).data('ttView');
  dataset = typeaheadView.datasets[0];
  empty.typeahead('destroy');
  return dataset;
};

$.fn.typeaheadInitial = function(dataset, limit) {
  if (dataset == null) {
    dataset = null;
  }
  if (limit == null) {
    limit = 10;
  }
  return this.each(function() {
    var $typeahead;
    $typeahead = $(this);
    dataset = createTypeaheadDataset(dataset);
    return $typeahead.on('focus', function(event) {
      var suggestions, typeaheadView;
      typeaheadView = $typeahead.data('ttView');
      if ((typeaheadView != null ? typeaheadView.inputView.getInputValue() : void 0) === '') {
        suggestions = values(dataset.itemHash).slice(0, limit);
        typeaheadView.dropdownView.open();
        typeaheadView.dropdownView.renderSuggestions(dataset, suggestions);
        return typeaheadView._clearHint();
      }
    });
  });
};
